import { useQuery } from "@tanstack/react-query";
import { API_CIRCUITS } from "../constants";
import { fetcher } from "../utils/fetcher";

export const useFetchCircuits = () => {
  return useQuery({
    queryKey: ["circuits"],
    queryFn: () => fetcher(API_CIRCUITS),
    select: (response) => response?.data ?? [],
    staleTime: 1000 * 60 * 60, // 1 hour cache window
  });
};
